import React from 'react';

interface StaticOneTrustIconProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export function StaticOneTrustIcon({ size = 'md', className = '' }: StaticOneTrustIconProps) {
  const sizeClasses = {
    sm: 'h-6 w-6',
    md: 'h-8 w-8',
    lg: 'h-10 w-10'
  };

  const baseClasses = `
    relative
    rounded-full
  `;
  
  return (
    <svg 
      viewBox="0 0 100 100" 
      className={`${sizeClasses[size]} ${baseClasses} ${className}`}
      fill="currentColor"
    >
      {/* Circle background without transitions */}
      <circle 
        cx="50" 
        cy="50" 
        r="48" 
        className="fill-current text-[#55A05F]"
      />
      
      {/* Text "ot" */}
      <text
        x="50"
        y="50"
        textAnchor="middle"
        dominantBaseline="middle"
        fill="white"
        fontSize="45"
        fontFamily="Arial, sans-serif"
        fontWeight="bold"
        style={{ textTransform: 'lowercase' }}
        className="select-none"
      >
        ot
      </text>
    </svg>
  );
}